// frontend/src/api/wallet.js
import { apiClient } from './index';

const walletApi = {
  getBalance: async () => {
    return await apiClient.get('/wallet/balance');
  },

  getTransactions: async () => {
    return await apiClient.get('/wallet/transactions');
  },

  /**
   * Fetch list of supported banks from backend (Flutterwave)
   */
  getBanks: async () => {
    return await apiClient.get('/wallet/banks');
  },

  requestWithdrawal: async (data) => {
    // data: { amount, bank_code, bank_name, account_number, account_name, notes }
    return await apiClient.post('/wallet/withdraw', data);
  },

  // --- ADMIN METHODS ---
  
  getAllPayouts: async (status = null) => {
    const url = status ? `/wallet/admin/payouts?status=${status}` : '/wallet/admin/payouts';
    return await apiClient.get(url);
  },

  processPayout: async (payoutId, status, notes = null) => {
    return await apiClient.post(`/wallet/admin/payouts/${payoutId}/process`, { status, admin_notes: notes });
  },

  /**
   * Manually credit a user's wallet (Admin Only)
   * @param {Object} data - { user_id, amount, reason }
   */
  manualCredit: async (data) => {
      return await apiClient.post('/wallet/admin/manual-credit', data);
  },

  // --- "I HAVE PAID" TOP-UP CLAIMS ---
  // Customer files a claim after a bank transfer.
  submitTopupClaim: async (data) => {
      // data: { amount, bank_label }
      return await apiClient.post('/wallet/topup-claim', data);
  },
  // Admin: list claims (status: 'pending' | 'approved' | 'declined' | omitted for all)
  getTopupClaims: async (status = null) => {
      const url = status ? `/wallet/admin/topup-claims?status=${status}` : '/wallet/admin/topup-claims';
      return await apiClient.get(url);
  },
  approveTopupClaim: async (claimId) => {
      return await apiClient.post(`/wallet/admin/topup-claims/${claimId}/approve`, {});
  },
  declineTopupClaim: async (claimId, note = null) => {
      return await apiClient.post(`/wallet/admin/topup-claims/${claimId}/decline`, { note });
  }
};

export { walletApi };